import React from 'react';
import { Select } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './EmployeeFilter.css';

interface Employee {
  id: number;
  first_name: string;
  last_name: string;
  role: string;
}

interface EmployeeFilterProps {
  employees: Employee[];
  selectedEmployees: number[];
  onChange: (employeeIds: number[]) => void;
}

export const EmployeeFilter: React.FC<EmployeeFilterProps> = ({
  employees,
  selectedEmployees,
  onChange
}) => {
  // Ensure employees is an array
  const employeeList = Array.isArray(employees) ? employees : [];

  return (
    <Select
      mode="multiple"
      placeholder="Filter by Employee"
      value={selectedEmployees}
      onChange={onChange}
      className="employee-filter"
      style={{ width: '100%', minWidth: 200 }}
      maxTagCount="responsive"
      showSearch
      filterOption={(input, option) => {
        const label = `${option?.label || ''}`.toLowerCase();
        return label.includes(input.toLowerCase());
      }}
      options={employeeList.map(emp => ({
        value: emp.id,
        label: `${emp.first_name} ${emp.last_name} (${emp.role === 'owner' ? 'Owner' : 'Technician'})`,
        icon: <UserOutlined />
      }))}
    />
  );
};
